<template>
  <div class="pop">
    <div class="luggage-list">
      <div class="luggage-item" v-for="(item, idx) in luggages" :key="idx">
        <div class="city-name">{{ item.depCityName }} - {{ item.arrCityName }}</div>
        <div class="luggage-content" style="display: flex; gap: 20px">
          <div v-for="(baggageItem, index) in item.baggageDetails" :key="index">
            <div class="luggage-left" v-if="baggageItem.weight">
              <img :src="baggageItem.imgUrl" class="luggage-left-img" />
              <div class="luggage-info">
                <div class="luggage-info-t">{{ baggageItem.baggageTypeDesc }}</div>
                <div>
                  至多{{ baggageItem.luggagePiece }} * {{ baggageItem.weight }}{{ baggageItem.weightUnit }}/人
                  <br />
                  {{ baggageItem.sizeText || '体积不超过' }}{{ baggageItem.size }}{{ baggageItem.sizeUnit }}
                  <br />
                  {{ baggageItem.remark }}
                </div>
              </div>
            </div>
            <div v-else class="luggage-left">
              <img src="https://static.a6air.com/sale/baggage/none_luggage.png" class="luggage-left-img" />
              <div class="luggage-info">
                <div class="luggage-info-t">无{{ baggageItem.baggageTypeDesc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    luggages: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  filters: {
    formatBagType(val) {
      return val === "CARRIAGE" ? "免费非托运行李" : val === "CHECK_IN" ? "免费托运行李" : "";
    }
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less" scoped>
.pop {
  width: 100%;
  display: flex;
  justify-content: flex-start;
}
.luggage-list {
  width: 100%;
  .luggage-item {
    border: 1px solid #dedede;
    border-radius: 8px;
    margin-bottom: 10px;
    overflow: hidden;
    &:last-child {
      margin-bottom: 0;
    }
    .city-name {
      background: #eee;
      color: #333;
      font-size: 16px;
      font-weight: bold;
      border-bottom: 1px solid #dedede;
      padding: 8px 0 8px 8px;
    }
    .luggage-content {
      padding: 10px;
    }
  }
}
.luggage-left,
.luggage-right {
  width: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.luggage-left-img {
  width: 100px;
  height: 100px;
  margin-right: 20px;
}
.luggage-info-t {
  font-weight: bold;
}
.pop-t {
  display: block;
  font-weight: bold;
}
</style>
